module.exports = __webpack_public_path__ + "img/customer_detail.63179d67.png";